import { FC } from "react";

import Grid from "@mui/material/Grid";

import { RateImagesCarousel } from "./RateImagesCarousel/RateImagesCarousel";

import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardInformationTooltip } from "@/dashboard-design-system/DashboardTooltip/DashboardInformationTooltip";
import { DashboardTypography } from "@/dashboard-design-system/Typography/DashboardTypography";

export const RateImagesField: FC = () => {
  const { t } = useTranslate();

  return (
    <Grid container direction="column">
      <Grid item container>
        <Grid item marginRight={0.5}>
          <DashboardTypography variant="body2">{t("dashboard", "ticketing.imageLabel")}</DashboardTypography>
        </Grid>
        <Grid item xs container alignItems="center">
          <DashboardInformationTooltip title={t("dashboard", "ticketing.imageLabelTooltip")} placement="top" />
        </Grid>
      </Grid>
      <Grid item marginTop={0.5}>
        <RateImagesCarousel />
      </Grid>
    </Grid>
  );
};
